export default function GoogleMapComponent(module) {
    angular.module(module)
        .component('googleMap', {
            bindings: {
                apiKey: '@',
                position: '<',
                items: '<',
                mapStyle: '<?',
                mappings: '<',
                initPromise: '<?',
                onMarkerClick: '&?'
            },
            controller: GoogleMapController,
            controllerAs: 'vm'
        });

    GoogleMapController.$inject = ['$element', 'helper', '$window', '$q'];
    function GoogleMapController($element, helper, $window, $q) {
        var vm = this;

        vm.$onInit = () => {
            vm._apiReady
                .then(() => {
                    if (vm.initPromise) {
                        vm.initPromise.then(vm._initMap);
                    }
                    else {
                        vm._initMap();
                    }
                })
        }

        vm.$onChanges = changes => {
            if (!vm._apiReady) {
                vm._mapPromise = $q.defer();
                vm._mapReady = vm._mapPromise.promise;
                vm._apiReady = helper.loadGoogleScripts(vm.apiKey);
            }
            vm._apiReady
                .then(() => {
                    return vm._mapReady;
                })
                .then(() => {
                    if (changes.position && changes.position.currentValue) {
                        if (!vm._initPosition) {
                            vm._initPosition = changes.position.currentValue;
                        }
                        vm._updatePosition();
                    }
                    if (changes.mapStyle && changes.mapStyle.currentValue) {
                        vm._updateStyle();
                    }
                    if (changes.items && changes.items.currentValue) {
                        vm._createMarkers();
                    }
                });
        }

        vm._initMap = () => {
            vm._map = new google.maps.Map($element[0], {
                zoom: 12,
                mapTypeControl: false,
                streetViewControl: false
            });
            vm._addLocationControl();
            if (vm.position) {
                vm._mapPromise.resolve();
            }
            vm._mapPromise.resolve();
        }

        vm._addLocationControl = () => {
            var controlDiv = document.createElement('div');

            var firstChild = document.createElement('button');
            firstChild.style.backgroundColor = '#fff';
            firstChild.style.border = 'none';
            firstChild.style.outline = 'none';
            firstChild.style.width = '40px';
            firstChild.style.height = '40px';
            firstChild.style.borderRadius = '2px';
            firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
            firstChild.style.cursor = 'pointer';
            firstChild.style.marginRight = '10px';
            firstChild.style.padding = '0';
            firstChild.title = 'Your Location';
            controlDiv.appendChild(firstChild);

            var secondChild = document.createElement('div');
            secondChild.style.margin = '7px';
            secondChild.style.width = '26px';
            secondChild.style.height = '26px';
            secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-2x.png)';
            secondChild.style.backgroundSize = '260px 26px';
            secondChild.style.backgroundPosition = '-234px 0';
            secondChild.style.backgroundRepeat = 'no-repeat';
            firstChild.appendChild(secondChild);

            google.maps.event.addListener(vm._map, 'center_changed', function () {
                secondChild.style['background-position'] = '-52px 0';
            });

            firstChild.addEventListener('click', function () {
                vm._map.setCenter(vm._initPosition);
                secondChild.style['background-position'] = '-234px 0';
            });

            controlDiv.index = 1;
            vm._map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
        }

        vm._updateStyle = () => {
            vm._map.setOptions({
                styles: vm.mapStyle
            });
        }

        vm._updatePosition = () => {
            vm._map.setCenter(vm.position);
        }

        vm._convertPosition = position => {
            return {
                lat: position.latitude,
                lng: position.longitude
            }
        }

        vm._createMarkers = () => {
            vm._clearMarkers();
            if (vm.items && vm.items.length) {
                var bounds = new google.maps.LatLngBounds();
                vm.items.forEach(item => {
                    var marker = new google.maps.Marker({
                        position: vm._getValue(item, vm.mappings.position),
                        map: vm._map,
                        label: {
                            text: vm._getValue(item, vm.mappings.number) + '',
                            fontWeight: '700',
                            fontFamily: 'Barlow, sans-serif',
                            fontSize: '1rem'
                        },
                        title: vm._getValue(item, vm.mappings.title),
                        icon: {
                            path: google.maps.SymbolPath.CIRCLE,
                            scale: 16,
                            fillColor: '#ECBC2F',
                            strokeWeight: 0.4,
                            fillOpacity: 1
                        }
                    });
                    if (vm.onMarkerClick) {
                        marker.addListener('click', () => {
                            vm.onMarkerClick({
                                item: item
                            });
                        });
                    }
                    bounds.extend(marker.getPosition());
                    vm._markers.push(marker);
                });
                vm._map.setCenter(bounds.getCenter());
                if (vm.items.length < 2) {
                    vm._map.setZoom(12);
                }
                else {
                    vm._map.fitBounds(bounds);
                }
            }
        }

        vm._getValue = (item, key) => {
            var keys = key.split('.');
            var val = item;
            keys.forEach(piece => {
                val = val[piece];
            });
            return val;
        }

        vm._clearMarkers = () => {
            if (vm._markers) {
                vm._markers.forEach(marker => {
                    marker.setMap(null);
                });
            }
            vm._markers = [];
        }
    }
}